
















import { DeliveryMethod, DeliveryMethodDetail } from '@/models/delivery'
import { PluginMixin } from '@spa/mixins/plugin'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Emit, Prop } from 'vue-property-decorator'

@Component
export default class SelectDeliveryMethod extends Mixins<PluginMixin>(
  PluginMixin
) {
  @Prop({ required: true })
  deliveryMethods: DeliveryMethod[]

  @Prop({ required: true })
  current: DeliveryMethodDetail

  get selectable(): boolean {
    return this.deliveryMethods.length > 1
  }

  get currentDescription(): string {
    return this.current.description
  }

  onChange(event) {
    this.changeDeliveryMethod(
      this.deliveryMethods.find(dm =>
        dm.id === event.target.value
      )!
    )
  }

  @Emit('change-delivery-method')
  changeDeliveryMethod(_dm: DeliveryMethod) {
    // do nothing
  }
}
